import { getConfig } from "./config";

async function request<T>(path: string, opts: RequestInit = {}): Promise<T> {
  const { apiBase } = getConfig();
  const headers = new Headers(opts.headers || {});
  if (opts.body && !headers.has("content-type")) {
    headers.set("content-type", "application/json");
  }
  const res = await fetch(`${apiBase}${path}`, { ...opts, headers });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error((data as { message?: string }).message || `HTTP ${res.status}`);
  }
  return data as T;
}

export const api = {
  publicStatus: (token: string) =>
    request<{ ok: boolean; subject: string; expiresAt: string }>(
      `/api/public/shares/${encodeURIComponent(token)}`
    ),
  publicVerify: (token: string, email: string) =>
    request<{
      subject: string;
      expiresAt: string;
      files: { fileId: string; fileName: string; sizeBytes: number }[];
      accessTicket: string;
    }>(`/api/public/shares/${encodeURIComponent(token)}/verify`, {
      method: "POST",
      body: JSON.stringify({ email }),
    }),
  publicDownload: (token: string, accessTicket: string, fileId: string) =>
    request<{ url: string; expiresInSeconds: number }>(
      `/api/public/shares/${encodeURIComponent(token)}/download`,
      {
        method: "POST",
        body: JSON.stringify({ accessTicket, fileId }),
      }
    ),
};
